import { Tooltip } from 'design-system-web';

export default Tooltip;
